import React, { useEffect, useState } from "react";
import DTOTaskDetailsModal from "./DTOTaskDetailsModal";
import TaskDetailsModalPresenter from "./TaskDetailsModalPresenter";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const TaskDetailsModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  return (
    <div>
      <DTOTaskDetailsModal />

      <TaskDetailsModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={trans}
      />
    </div>
  );
};

export default TaskDetailsModalController;
